(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(function () {
  'use strict';

  /* Builds the contents list and the reading line. Returns a cleanup, so a theme editor re-render can
     drop the old listeners and build again on the new markup. */
  function initArticleToc() {
    var body = document.getElementById('articleBody');
    var toc = document.getElementById('articleToc');
    if (!body || !toc) return null;

    /* The post text renders in two parts when it has a FAQs heading (split in Liquid above). */
    var faqs = document.getElementById('articleFaqs');
    var headings = document.querySelectorAll('#articleBody h2, #articleFaqs h2');
    if (!headings.length) return null;

    /* Reserve every id already on the page, so a generated id never repeats an existing one. */
    var usedIds = {};
    document.querySelectorAll('[id]').forEach(function (el) { usedIds[el.id] = true; });
    var entries = [];

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var slug = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (!slug) slug = 'section-' + (index + 1);
        var id = slug;
        var suffix = 1;
        while (usedIds[id]) {
          suffix += 1;
          id = slug + '-' + suffix;
        }
        usedIds[id] = true;
        heading.id = id;
      }
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      var number = document.createElement('span');
      number.className = 'toc-n';
      number.textContent = String(index + 1).padStart(2, '0');
      var label = document.createElement('span');
      label.className = 'toc-t';
      label.textContent = heading.textContent.trim();
      link.appendChild(number);
      link.appendChild(label);
      toc.appendChild(link);
      entries.push({ id: heading.id, link: link });
    });

    /* Reading progress: how far through the post text (both parts) the reader is, as a thin line under the heading. */
    var progress = document.getElementById('articleTocProgress');
    var updateProgress = null;
    if (progress) {
      updateProgress = function () {
        var top = body.getBoundingClientRect().top;
        var bottom = (faqs || body).getBoundingClientRect().bottom;
        var rect = { top: top, height: bottom - top };
        var span = rect.height - window.innerHeight * 0.6;
        var done = span > 0 ? Math.min(1, Math.max(0, -rect.top / span)) : 1;
        progress.style.transform = 'scaleX(' + done.toFixed(3) + ')';
      };
      window.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (observed) {
        observed.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entries.forEach(function (item) {
            item.link.classList.toggle('on', item.id === entry.target.id);
          });
        });
      }, { rootMargin: '-96px 0px -70% 0px' });
      headings.forEach(function (heading) { observer.observe(heading); });
    }

    return function () {
      if (updateProgress) window.removeEventListener('scroll', updateProgress);
      if (observer) observer.disconnect();
    };
  }

  var cleanup = initArticleToc();
  /* Theme editor: the bundled script runs once per page, so a re-rendered article section is set up here. */
  document.addEventListener('shopify:section:unload', function (event) {
    if (cleanup && event.target.querySelector('#articleToc')) { cleanup(); cleanup = null; }
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('#articleToc')) cleanup = initArticleToc();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* ---- filter panel + sort sheet open/close ------------------------- */
    /* The theme editor replaces this section's markup on a settings change (shopify:section:load)
       without running this script again, so the element references are looked up again on every
       click, and every listener below is delegated from document. */
    var filterPanel, sortSheet, overlay;
    function findLayers() {
      filterPanel = document.getElementById('plpFilterPanel');
      sortSheet = document.getElementById('plpSortSheet');
      overlay = document.getElementById('plpOverlay');
    }
    findLayers();
    /* Dialog focus handling, same pattern as the menu drawer in raayaa-chrome.js:
       focus moves into the open layer, Tab stays inside it, and closing returns
       focus to the button that opened it. */
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    var openLayerElement = null;
    var layerOpener = null;

    function setOpenersExpanded(layer, expanded) {
      if (!layer) return;
      document.querySelectorAll('[aria-controls="' + layer.id + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
    function focusableInLayer(layer) {
      return Array.prototype.slice.call(layer.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }
    function closeAll() {
      var wasOpen = openLayerElement;
      if (filterPanel) {
        filterPanel.classList.remove('open');
        filterPanel.setAttribute('inert', '');
        setOpenersExpanded(filterPanel, false);
      }
      if (sortSheet) {
        sortSheet.classList.remove('open');
        sortSheet.setAttribute('inert', '');
        setOpenersExpanded(sortSheet, false);
      }
      if (overlay) overlay.classList.remove('open');
      openLayerElement = null;
      if (wasOpen && layerOpener && layerOpener.focus) layerOpener.focus(); /* return focus to the opener */
      layerOpener = null;
    }
    function openLayer(layer, opener) {
      closeAll();
      if (!layer) return;
      layerOpener = opener || document.activeElement;
      openLayerElement = layer;
      layer.classList.add('open');
      layer.removeAttribute('inert');
      if (overlay) overlay.classList.add('open');
      setOpenersExpanded(layer, true);
      var closeButton = layer.querySelector('[data-plp-close]');
      if (closeButton) closeButton.focus();
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var filterOpener = e.target.closest('[data-plp-filter-open]');
      var sortOpener = e.target.closest('[data-plp-sort-open]');
      if (filterOpener || sortOpener) findLayers();
      if (filterOpener) openLayer(filterPanel, filterOpener);
      if (sortOpener) openLayer(sortSheet, sortOpener);
      if (e.target.closest('[data-plp-close]') || e.target.closest('#plpOverlay')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (openLayerElement) closeAll(); return; }
      if (e.key !== 'Tab' || !openLayerElement) return;
      var items = focusableInLayer(openLayerElement);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!openLayerElement.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });

    /* ---- sort: select (desktop) + sheet options (mobile) -------------- */
    function applySort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-plp-sort-select]')) applySort(e.target.value);
    });
    document.addEventListener('click', function (e) {
      var option = e.target.closest && e.target.closest('[data-plp-sort]');
      if (option) applySort(option.dataset.plpSort);
    });

    /* ---- sort select: as wide as the chosen option, so the caret sits right after the words (founder,
       2026-09-27). A native select is as wide as its longest option. ---- */
    var sortSelect = null;
    function sizeSortSelect() {
      sortSelect = document.querySelector('.toolbar [data-plp-sort-select]');
      if (!sortSelect || !sortSelect.options.length) return;
      var style = getComputedStyle(sortSelect);
      var context = document.createElement('canvas').getContext('2d');
      context.font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
      var words = sortSelect.options[sortSelect.selectedIndex].text;
      /* Room for the caret even before the stylesheet's 18px padding arrives. */
      var caretRoom = Math.max(parseFloat(style.paddingRight) || 0, 20);
      sortSelect.style.width = Math.ceil(context.measureText(words).width + caretRoom + 2) + 'px';
    }
    sizeSortSelect();
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.toolbar [data-plp-sort-select]')) sizeSortSelect();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeSortSelect);

    /* ---- load more: fetch the next paginated page, append its cards ---
       Auto-load (founder, 2026-09-27): when the Load more block comes within 1200px of the screen, the next page
       loads by itself. Once the shopper scrolls past the grid (the bottom of the last row reaches the header),
       auto-load stops for this visit and the button stays for manual loads; a manual click turns it back on. */
    var autoLoad = true;

    /* Prefetch: the next page is fetched in the background as soon as the current rows show, so an auto-load
       adds its rows at once instead of waiting on the network. */
    var pageCache = {};
    /* Only this section comes back (Shopify section rendering: section_id), not the header, footer
       and drawers of a full page. The page, sort and filter parameters in the URL stay as they are. */
    function sectionOnlyUrl(url) {
      var grid = document.querySelector('[data-plp-grid]');
      var sectionId = grid && grid.dataset.sectionId;
      if (!sectionId) return url;
      var target = new URL(url, window.location.href);
      target.searchParams.set('section_id', sectionId);
      return target.toString();
    }
    function getPage(url) {
      if (!pageCache[url]) {
        pageCache[url] = fetch(sectionOnlyUrl(url)).then(function (response) { return response.text(); });
        pageCache[url].catch(function () { delete pageCache[url]; });
      }
      return pageCache[url];
    }
    function prefetchNext() {
      var next = document.querySelector('[data-plp-next]');
      if (next) getPage(next.href);
    }

    function loadNext(button, isAuto) {
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      var loadmoreEl = document.querySelector('[data-plp-loadmore]');
      button.setAttribute('aria-busy', 'true');
      button.textContent = (loadmoreEl && loadmoreEl.dataset.loadingLabel) || 'Loading…';

      getPage(button.href)
        .then(function (html) {
          /* The shopper left the grid while this page loaded: do not add rows above them. */
          if (isAuto && !autoLoad) {
            button.textContent = button.dataset.labelLoadMore || 'Load more';
            button.removeAttribute('aria-busy');
            return;
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('[data-plp-grid]');
          var freshGrid = doc.querySelector('[data-plp-grid]');
          if (!grid || !freshGrid) { window.location.assign(button.href); return; }

          var fragment = document.createDocumentFragment();
          while (freshGrid.firstElementChild) fragment.appendChild(freshGrid.firstElementChild);
          grid.appendChild(fragment);

          var loadmore = document.querySelector('[data-plp-loadmore]');
          var shown = grid.querySelectorAll('.pcard').length;
          var total = parseInt(loadmore.dataset.total, 10) || shown;
          var count = loadmore.querySelector('[data-plp-count]');
          var fill = loadmore.querySelector('[data-plp-fill]');
          if (count) {
            var template = loadmore.dataset.progressTemplate || "You've seen [shown] of [total]";
            count.textContent = template.replace('[shown]', shown).replace('[total]', total);
          }
          if (fill) fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';

          var freshNext = doc.querySelector('[data-plp-next]');
          if (freshNext) {
            /* A section response can carry section_id in its pagination links; the button must keep
               a full-page URL, because a failed load navigates to it. */
            var nextUrl = new URL(freshNext.getAttribute('href'), window.location.href);
            nextUrl.searchParams.delete('section_id');
            button.href = nextUrl.pathname + nextUrl.search;
            button.textContent = button.dataset.labelLoadMore || 'Load more';
            button.removeAttribute('aria-busy');
            prefetchNext();
            checkAutoLoad();
          } else {
            button.remove();
          }
          document.dispatchEvent(new CustomEvent('raayaa:content-updated'));
        })
        .catch(function () { window.location.assign(button.href); });
    }

    document.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-plp-next]');
      if (!button) return;
      e.preventDefault();
      autoLoad = true;
      loadNext(button, false);
    });

    /* One scroll check drives auto-load (an IntersectionObserver never fires in a hidden tab):
       - the grid's bottom at or above the header's lower edge -> the shopper passed the products: stop;
       - else the Load more block within 1200px of the screen -> load the next page. */
    var header = document.querySelector('.site-header');
    function checkAutoLoad() {
      if (!autoLoad) return;
      var grid = document.querySelector('[data-plp-grid]');
      var loadmore = document.querySelector('[data-plp-loadmore]');
      var next = document.querySelector('[data-plp-next]');
      if (!grid || !loadmore || !next) return;
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      if (grid.getBoundingClientRect().bottom <= headerBottom) { autoLoad = false; return; }
      if (loadmore.getBoundingClientRect().top < window.innerHeight + 1200) loadNext(next, true);
    }
    /* Three rectangle reads per scroll event: cheap, and it also runs where animation frames pause. */
    window.addEventListener('scroll', checkAutoLoad, { passive: true });
    prefetchNext();
    checkAutoLoad();

    /* Theme editor: the section's markup was replaced. Drop the old open layer and point at the new
       controls; the delegated listeners above already reach them. */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target.querySelector || !e.target.querySelector('[data-plp-grid], #plpSortSheet')) return;
      openLayerElement = null;
      layerOpener = null;
      findLayers();
      sizeSortSelect();
      autoLoad = true;
      prefetchNext();
      checkAutoLoad();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspirations-chapters"] && !Shopify.designMode) return;
  try {
    
  // Measure each copy box's height so CSS can pin its middle to the middle
  // of the screen. Sticky does not change it, so load and resize are enough.
  function measureInspirationRails() {
    document.querySelectorAll('.insp-ch__text').forEach(function (rail) {
      rail.style.setProperty('--text-h', rail.offsetHeight + 'px');
    });
  }
  measureInspirationRails();
  window.addEventListener('resize', measureInspirationRails);
  window.addEventListener('load', measureInspirationRails);

  // The flatten. The moment the copy has fully cleared the photo column's
  // bottom it switches to the story width; above that line it keeps its column.
  function flattenInspirationCopy() {
    document.querySelectorAll('.insp-ch__story').forEach(function (story) {
      var text = story.querySelector('.insp-ch__text');
      var pics = story.querySelector('.insp-ch__pics');
      if (!text || !pics || getComputedStyle(text).position !== 'sticky') return;
      var box = text.getBoundingClientRect();
      var progress = box.top >= pics.getBoundingClientRect().bottom ? 1 : 0;
      var column = text.parentElement.clientWidth;
      var full = story.clientWidth - parseFloat(getComputedStyle(story).paddingLeft) - parseFloat(getComputedStyle(story).paddingRight);
      text.style.setProperty('--grow', (progress * Math.max(full - Math.min(column, 440), 0)) + 'px');
      text.classList.toggle('is-flat', progress === 1);
    });
  }
  window.addEventListener('scroll', flattenInspirationCopy, { passive: true });
  window.addEventListener('resize', flattenInspirationCopy);
  flattenInspirationCopy();

  // A swipeable strip with dots: one dot per page, --near set from the scroll
  // position so the pill flows dot to dot. Auto-advance one page at a time,
  // back to the first page after the last; pauses while the pointer is over
  // the strip or keyboard focus is in it, and a pause button holds it; off
  // when the delay is 0 or for reduced motion. Returns a cleanup function, or
  // null when the strip does not scroll, so the caller can try again later.
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setupCarousel(strip, delay, dotsModifier) {
    var gap = function () { return parseFloat(getComputedStyle(strip).columnGap) || 0; };
    var pageWidth = function () { return strip.clientWidth + gap(); };
    var maxLeft = function () { return strip.scrollWidth - strip.clientWidth; };
    var pageCount = function () { return Math.ceil((strip.scrollWidth + gap()) / pageWidth()); };
    // Scroll only to a snap point (an item's start, or the very end). A target between two cards made the
    // browser's mandatory snap pull the strip a second time after the smooth scroll: a double jerk on every
    // auto-advance and pager tap (founder: "in-component scrolling is a bit broken", 2026-09-28).
    var snapLeft = function (target) {
      var base = strip.getBoundingClientRect().left - strip.scrollLeft;
      var best = maxLeft();
      var bestDistance = Math.abs(best - target);
      Array.prototype.forEach.call(strip.children, function (item) {
        var left = Math.min(item.getBoundingClientRect().left - base, maxLeft());
        var distance = Math.abs(left - target);
        if (distance < bestDistance) { best = left; bestDistance = distance; }
      });
      return Math.max(0, Math.round(best));
    };
    var scrollToLeft = function (target) {
      strip.scrollTo({ left: snapLeft(target), behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    var goTo = function (page) { scrollToLeft(Math.min(page * pageWidth(), maxLeft())); };
    if (pageCount() < 2) return null;
    // A scrolling strip with nothing focusable inside (the photo strip) must still be reachable by keyboard
    // (WCAG 2.1.1): give it a tab stop and a name. Card strips already hold links and buttons.
    if (!strip.querySelector('a[href], button')) {
      var chapterHeading = strip.closest('.insp-ch') && strip.closest('.insp-ch').querySelector('.insp-ch__h');
      strip.tabIndex = 0;
      strip.setAttribute('role', 'region');
      strip.setAttribute('aria-label', chapterHeading ? chapterHeading.textContent.trim() : 'Photos');
    }
    var pages = pageCount();
    var dots = document.createElement('div');
    dots.className = dotsModifier ? 'insp-ch__dots ' + dotsModifier : 'insp-ch__dots';
    strip.insertAdjacentElement('afterend', dots);
    var currentPage = function () {
      // The last page is usually short, so the last step runs from the start
      // of the second-to-last page to the end of the strip.
      var lastStart = (pages - 2) * pageWidth();
      if (strip.scrollLeft <= lastStart) return strip.scrollLeft / pageWidth();
      return pages - 2 + (strip.scrollLeft - lastStart) / Math.max(maxLeft() - lastStart, 1);
    };
    // The shared scroll pager (3 or 5 positions, a tab that follows the scroll).
    // raayaaPager empties its host, so a rebuild puts the pause button back.
    var pager = null;
    var pauseButton = null;
    var buildPager = function () {
      pager = window.raayaaPager(dots, {
        positions: pages,
        label: 'Go to page position',
        onJump: function (progress) { scrollToLeft(progress * maxLeft()); }
      });
      if (pauseButton) dots.appendChild(pauseButton);
    };
    buildPager();
    var markDot = function () { pager.update(maxLeft() ? strip.scrollLeft / maxLeft() : 0); };
    strip.addEventListener('scroll', markDot, { passive: true });
    markDot();
    // A width change changes the page count (four cards to a row on desktop, 2.5 on phones). Recount, so the
    // dots and the jump back to the first page follow the new layout.
    var onResize = function () {
      var count = pageCount();
      if (count < 2 || count === pages) return;
      pages = count;
      buildPager();
      markDot();
    };
    window.addEventListener('resize', onResize);
    var timer = null;
    var observer = null;
    var cleanup = function () {
      window.removeEventListener('resize', onResize);
      if (timer) clearInterval(timer);
      if (observer) observer.disconnect();
    };
    if (!delay || reducedMotion) return cleanup;
    var paused = false;
    var focusPaused = false;
    // Once a shopper touches, drags or wheels the strip, auto-advance stops for good: on touch screens the
    // pointer events only paused it while a finger was down, so it jumped the strip during the swipe's
    // momentum and snap (founder: "scrolling is broken on smaller devices", 2026-09-28). The pause button
    // then shows play; only a press on it starts the strip again.
    var stopped = false;
    pauseButton = document.createElement('button');
    pauseButton.type = 'button';
    pauseButton.className = 'insp-ch__pause pause-btn';
    var syncPauseButton = function () {
      pauseButton.setAttribute('aria-pressed', stopped ? 'true' : 'false');
      pauseButton.setAttribute('aria-label', (stopped ? strip.dataset.labelPlay : strip.dataset.labelPause) || '');
      pauseButton.innerHTML = stopped ? '&#9654;' : '&#10074;&#10074;';
    };
    pauseButton.addEventListener('click', function () { stopped = !stopped; syncPauseButton(); });
    syncPauseButton();
    dots.appendChild(pauseButton);
    var stop = function () {
      if (stopped) return;
      stopped = true;
      syncPauseButton();
    };
    strip.addEventListener('touchstart', stop, { passive: true });
    strip.addEventListener('wheel', stop, { passive: true });
    strip.addEventListener('pointerdown', stop);
    strip.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
    strip.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });
    // Keyboard focus in the strip or on its dots holds it still (a mouse click on a dot does not).
    [strip, dots].forEach(function (area) {
      area.addEventListener('focusin', function (e) {
        try { if (!e.target.matches(':focus-visible')) return; } catch (err) {}
        focusPaused = true;
      });
      area.addEventListener('focusout', function (e) {
        if (!strip.contains(e.relatedTarget) && !dots.contains(e.relatedTarget)) focusPaused = false;
      });
    });
    // Advance only while the strip is on screen.
    var visible = true;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; });
      observer.observe(strip);
    }
    timer = setInterval(function () {
      if (paused || stopped || focusPaused || !visible || document.hidden) return;
      var next = Math.round(currentPage()) + 1;
      goTo(next >= pages ? 0 : next);
    }, delay);
    return cleanup;
  }

  // Each strip keeps its cleanup (and the photo strips their resize retry) on the element, so a theme editor
  // re-render can release the old ones.
  function initInspirationCarousels(scope) {
    scope.querySelectorAll('[data-auto-scroll]').forEach(function (strip) {
      strip.inspCleanup = setupCarousel(strip, parseInt(strip.getAttribute('data-auto-scroll'), 10), '');
    });
    // The photo strips scroll only at 900px and narrower. When the page loads
    // wider, the strip is a column and setup declines; try again on each
    // resize until it takes.
    scope.querySelectorAll('.insp-ch__pics').forEach(function (pics) {
      var delay = parseInt(pics.getAttribute('data-auto-advance'), 10) || 0;
      pics.inspCleanup = setupCarousel(pics, delay, 'insp-ch__dots--pics');
      if (pics.inspCleanup) return;
      // One frame later, so the narrow-screen layout has applied before the strip is measured.
      var retry = function () {
        requestAnimationFrame(function () {
          if (pics.inspCleanup || !pics.isConnected) return;
          pics.inspCleanup = setupCarousel(pics, delay, 'insp-ch__dots--pics');
          if (pics.inspCleanup) window.removeEventListener('resize', retry);
        });
      };
      pics.inspRetry = retry;
      window.addEventListener('resize', retry);
    });
  }
  initInspirationCarousels(document);

  // Theme editor: this bundled script runs once per page, so a re-rendered section is set up here, and the
  // section it replaces releases its timers, observers and window listeners.
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-auto-scroll], .insp-ch__pics').forEach(function (el) {
      if (el.inspCleanup) el.inspCleanup();
      if (el.inspRetry) window.removeEventListener('resize', el.inspRetry);
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target.querySelector('.insp-ch')) return;
    // The shared reveal observer only saw the first page load: show the new section's text and photos now.
    event.target.querySelectorAll('.ed-reveal').forEach(function (el) { el.classList.add('in'); });
    measureInspirationRails();
    flattenInspirationCopy();
    initInspirationCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
